import { Label } from "@/components/ui/label";
import { useAppForm } from "@/hooks/useForm";
import { AddProyectoSchema } from "./Proyecto.schema";
import { revalidateLogic } from "@tanstack/react-form";
import { DefaultValuesSchema } from "@/lib/utils";

interface NewProyectoFormProps {
	readonly id: string;
	readonly onSubmit: (data: AddProyectoSchema) => void;
}
export function ProyectoForm(props: NewProyectoFormProps) {
	const form = useAppForm({
		defaultValues: {
			nombre: "",
			descripcion: "",
			referencia: "",
			externo: "propio",
			alcance: "cuna_puerta",
		} satisfies AddProyectoSchema as AddProyectoSchema,
		validationLogic: revalidateLogic(),
		validators: {
			onChange: DefaultValuesSchema(AddProyectoSchema),
			onSubmit: AddProyectoSchema,
		},
		onSubmit: (formProps) => props.onSubmit(formProps.value),
	});
	return (
		<form
			id={props.id}
			onSubmit={(e) => {
				e.preventDefault();
				void form.handleSubmit(e);
			}}
			className="space-y-8"
		>
			<form.AppField
				name="nombre"
				children={(field) => (
					<div>
						<Label>Nombre</Label>
						<field.TextField placeholder="Nombre" type="text" />
					</div>
				)}
			/>

			<form.AppField
				name="descripcion"
				children={(field) => (
					<div>
						<Label>Descripción</Label>
						<field.TextField placeholder="Descripción" type="text" />
					</div>
				)}
			/>

			<form.AppField
				name="referencia"
				children={(field) => (
					<div>
						<Label>Referencia</Label>
						<field.TextField placeholder="Referencia" type="text" />
					</div>
				)}
			/>


			<form.AppField
				name="externo"
				children={(field) => (
					<div>
						<Label>Externo</Label>
						<field.SelectField
							options={{
								propio: "Propio",
								externo: "Externo",
							}}
						/>
					</div>
				)}
			/>

			<form.AppField
				name="alcance"
				children={(field) => (
					<div>
						<Label>Alcance</Label>
						<field.SelectField
							options={{
								cuna_puerta: "De cuna a puerta",
								puerta_puerta: "De puerta a puerta",
							}}
						/>
					</div>
				)}
			/>
		</form>
	);
}